"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var evaluate_1 = require("./evaluate");
var utils_1 = require("./utils");
exports.createExpressionReducer = function (config) { return function (map) { return function (state, path) {
    try {
        var expression = map[path];
        var newState = evaluate_1.evaluate(state, path, expression);
        return newState;
    }
    catch (e) {
        utils_1.throwError(e, config.errorOnEval);
        return state;
    }
}; }; };
//# sourceMappingURL=reduce.js.map